var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGamificacion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96.9 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#162975;}.cls-2{fill:#c62217;}.cls-3{fill:#fff;}.cls-4{fill:#191a34;}.cls-5{fill:#233982;}.cls-6{fill:#e6ab31;}.cls-7{fill:#7a87c2;}.cls-8{fill:#333;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "marco_avatar",
    "data-name": "marco avatar"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.86,70.62a2.64,2.64,0,0,1-2.29-2.72,2.48,2.48,0,0,1,2.09-2.55,6.58,6.58,0,0,1,2.12-3.09H25c-2.14,0-2.2-.06-2.2-2.16V8.41c0-2.12.1-2.23,2.16-2.24H63.41c2.09,0,2.2.12,2.2,2.2V44.14a6.47,6.47,0,0,1,5.36.2V5.83C71,3,70,1.06,67.3,0H21.11c-2.62,1.06-3.68,3-3.67,5.83V66.89c0,2.8,1,4.78,3.67,5.84H45.38A7.38,7.38,0,0,1,43.86,70.62Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 39.46,
    cy: 30.45,
    r: 13.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 39.46,
    cy: 30.45,
    r: 10.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 39.46,
    cy: 30.45,
    r: 7.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 39.46,
    cy: 30.45,
    r: 3.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "38.82 29.86 53.54 21.97 54.23 18.32 60.01 15.83 60.11 19.33 60.48 19.43 38.82 30.34 38.82 29.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "60.48 19.43 60.59 20.17 62.81 21.76 56.46 24.73 54.29 23.46 39.41 30.55 38.82 30.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M53.06,65.38c-.06-.17-.11-.29-.17-.42L47.13,52.31,41.59,40.16a3,3,0,1,1,5.5-2.54c1.7,3.7,3.38,7.41,5.07,11.11.05.12.11.23.19.41l.17-.55a3,3,0,0,1,5.6-.32,10.4,10.4,0,0,0,.54,1v-.17a3,3,0,0,1,5.75-1.77c.33.7.64,1.4,1,2.09l-.06-.38A3,3,0,0,1,71,47.32c.79,1.62,1.51,3.28,2.26,4.92,1.56,3.42,3.13,6.83,4.67,10.26a11,11,0,0,1-2.14,12,10.52,10.52,0,0,1-6.36,3.22,12.34,12.34,0,0,1-5.56-.52c-1.88-.63-3.73-1.34-5.58-2L48.08,71.37a3.66,3.66,0,1,1,2.55-6.86l2.16.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M33.18,38.48A10.7,10.7,0,0,0,37.55,47a10.4,10.4,0,0,0,5.61,2.12h.33a.87.87,0,0,1,.77.89.89.89,0,0,1-.93.81A12.47,12.47,0,0,1,37.55,49a12.29,12.29,0,0,1-5.64-7.51A12.55,12.55,0,1,1,56.18,35.1,12.1,12.1,0,0,1,56.53,37a12.3,12.3,0,0,1-1.85,7.93A.86.86,0,1,1,53.22,44a10.61,10.61,0,0,0,1.66-5.69,10.23,10.23,0,0,0-2.63-7.13,10.83,10.83,0,0,0-18.44,3.45A11.3,11.3,0,0,0,33.18,38.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M44.06,31.24a7.07,7.07,0,0,1,6.93,6,6.92,6.92,0,0,1-.2,3,.85.85,0,0,1-.76.63.76.76,0,0,1-.82-.49,1.58,1.58,0,0,1,0-.75A5.31,5.31,0,1,0,41.56,43,.89.89,0,0,1,42,44.16s0,0,0,.05a.88.88,0,0,1-1.19.33l0,0a7,7,0,0,1,2.38-13.16A7,7,0,0,1,44.06,31.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2,90V89H1V88H0V84H1V83H2V82H6v1H7v1H5V83H3v1H2v4H3v1H5V86.51H3v-1H7V90Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8.43,90V84h1V83h1V82h3v1h1v1h1v6h-2V87h-3v3Zm5-4V84h-1V83h-1v1h-1v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16.88,90V82h1v1h1v1h1v1h1V84h1V83h1V82h1V90h-2V86h-1v1h-1V86h-1v4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25.32,90V89h2V83h-2V82h6v1h-2v6h2v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.77,90V82h7v1h-5v2h3v1h-3v4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41.22,90V89h2V83h-2V82h6v1h-2v6h2v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M50.66,90V89h-1V88h-1V84h1V83h1V82h4v1h1v1h-2V83h-2v1h-1v4h1v1h2V88h2v1h-1v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M57.11,90V84h1V83h1V82h3v1h1v1h1v6h-2V87h-3v3Zm5-4V84h-1V83h-1v1h-1v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.55,90V89h-1V88h-1V84h1V83h1V82h4v1h1v1h-2V83h-2v1h-1v4h1v1h2V88h2v1h-1v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74,90V89h2V83H74V82h6v1H78v6h2v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M82.45,90V89h-1V83h1V82h5v1h1v6h-1v1Zm4-1V83h-3v6ZM84,81V80h1V79h2v1H86v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M89.9,90V82h1v1h1v1h1v1h1v1h1V82h2V90h-1V89h-1V88h-1V87h-1V86h-1v4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M36.65,97V94.08h0c-.29.71-1.78,4-2.59,5.84h-.21c-.87-2-2.23-5.07-2.53-5.84h0v5.84h-.17v-6h.27c1,2.24,2.28,5.21,2.54,5.79h0c.21-.49,1.66-3.71,2.58-5.79h.27v6h-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M38.64,93.92v3.74a1.91,1.91,0,0,0,2,2.18c1.28,0,2-.75,2-2.18V93.92h.17v3.71c0,1.79-.91,2.36-2.14,2.36a2,2,0,0,1-2.15-1.84,1.89,1.89,0,0,1,0-.41V93.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M46,99.91l-2.3-6h.18l1.29,3.33c.37,1,.78,2,.93,2.47h0c.13-.39.61-1.57,1-2.45l1.33-3.35h.19l-2.39,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M49.82,93.92v6h-.17v-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M56,98.32A2.2,2.2,0,0,1,53.73,100c-1.73,0-2.57-1.37-2.57-3s.84-3.11,2.62-3.11A2.13,2.13,0,0,1,56,95.59h-.18a2,2,0,0,0-2-1.59c-1.71,0-2.44,1.38-2.44,3s.74,2.88,2.4,2.88a2.07,2.07,0,0,0,2.08-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M58.74,99.91V97.46a.23.23,0,0,0-.06-.12l-2.09-3.42h.2c.67,1.08,1.86,3,2,3.33.23-.41,1.37-2.19,2.07-3.33h.2L59,97.33a.24.24,0,0,0,0,.12v2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M63.71,94.08H61.59v-.16H66v.16H63.88v5.83h-.17Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamificacion);
export default __webpack_public_path__ + "static/media/gamificacion.5a6a17601d3bdc3d44d9d19cca75ab5d.svg";
export { ForwardRef as ReactComponent };